import {api} from "../core/api";
import {handleHttp, IProps} from "../core/handleHttp";

const preAlias = "/v1/grupo";

export const getGrupos = async () => {
    let req: IProps = {
        api: api,
        type: "get",
        url: `${preAlias}`
    }
    return await handleHttp(req)
}